var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "opt-group" }, [
    _c("div", { staticClass: "menu-buttons" }, [
      _vm._v("\n    " + _vm._s(_vm.record.bkNo) + "\n  "),
    ]),
    _vm._v(" "),
    !_vm.validateNull(_vm.record.jpyAmount) && _vm.record.jpyAmount !== "0"
      ? _c("div", { staticClass: "menu-buttons" }, [
          _c("img", {
            attrs: { src: require("@/assets/icon/yen_mark2.jpg"), alt: "" },
          }),
          _vm._v("JPY:" + _vm._s(_vm.record.jpyAmount) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }